import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'


export const cseSegmentedControl = {
  backgroundColor: css`var(--cse-segmented-control-background-color, ${csColorBackground.secondary})`,
  paddingBlock: css`var(--cse-segmented-control-padding-y, ${csSpacing.spacing03})`,
  paddingInline: css`var(--cse-segmented-control-padding-x, ${csSpacing.spacing03})`,
  borderRadius: css`var(--cse-segmented-control-border-radius, ${csBorder.radiusMedium})`,
  borderWidth: css`var(--cse-segmented-control-border-width, ${csSpacing.spacingnone})`,
  borderColor: css`var(--cse-segmented-control-border-color, ${csColorBorder.light})`,
}

export const cseSegmentedControlIndicator = {
  backgroundColor: css`var(--cse-segmented-control-indicator-background-color, ${csColorBackground.primary})`,
  borderRadius: css`var(--cse-segmented-control-indicator-border-radius, ${csBorder.radiusMedium})`,
  boxShadow: css`var(--cse-segmented-control-indicator-box-shadow, ${csShadow.downSmall})`,
}

export const style: CSSResult = css`
  .cse-segmented-control {
    display: flex;
    align-items: center;
    position: relative;
    border: ${cseSegmentedControl.borderWidth} solid ${cseSegmentedControl.borderColor};
    background-color: ${cseSegmentedControl.backgroundColor};
    padding-block: ${cseSegmentedControl.paddingBlock};
    padding-inline: ${cseSegmentedControl.paddingInline};
    border-radius: ${cseSegmentedControl.borderRadius};
    white-space: nowrap;
    max-width: 100%;
    overflow-x: auto;
  }

  .cse-segmented-control.fit-fit {
    width: fit-content;
  }

  .cse-segmented-control__indicator.animate {
    transition-duration: ${csTransition.duration};
  }

  .cse-segmented-control__indicator {
    position: absolute;
    top: ${cseSegmentedControl.paddingBlock};
    left: 0;
    background-color: ${cseSegmentedControlIndicator.backgroundColor};
    border-radius: ${cseSegmentedControlIndicator.borderRadius};
    box-shadow: ${cseSegmentedControlIndicator.boxShadow};
    transition-property: left, width, height;
    transition-timing-function: ${csTransition.timingFunction};
    pointer-events: none;
    z-index: 0;
  }
`
